import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CommonFunctionsService } from './_services/index';
import { Router,ActivatedRoute,ParamMap } from '@angular/router';
@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css'],
	providers:[CommonFunctionsService]
})
export class AppComponent {
  title = 'ExpediUSA';
  isBrowser : any = false;

  constructor(
	  @Inject(PLATFORM_ID) private platformId: Object,
	  private route: ActivatedRoute, 
	  public router: Router,
	  private commonFunctionsService:CommonFunctionsService
	){} 

  	/**This function are used for when activte the url then move window.*/
	onActivate(e: any, outlet: any){ 
		if(isPlatformBrowser(this.platformId)) { 
			setTimeout(()=>{
				window.scrollTo(0, 0);
			},500);
		} 
	} 
  
}  
 
